// src/main.js

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import apiClient from './services/auth'

// Make axios instance available in all components
Vue.prototype.$http = apiClient

// Prevent production tip
Vue.config.productionTip = false

// Create the Vue instance
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')